import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getCustomGeoZones: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONES,
	},
	getCustomGeoZone: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE,
	},
	createCustomGeoZone: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].CREATE_CUSTOM_GEO_ZONE,
	},
	putCustomGeoZone: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].PUT_CUSTOM_GEO_ZONE,
	},
	patchCustomGeoZone: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].PATCH_CUSTOM_GEO_ZONE,
	},
	deleteCustomGeoZone: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].DELETE_CUSTOM_GEO_ZONE,
	},
	getCustomGeoZonePreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE_PREVIEW,
	},
	getCustomGeoZonePopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES].GET_CUSTOM_GEO_ZONE_POPUP,
	},
}
